export default function stripHtml(html: string) {
  const initialDiv = document.createElement('div');
  initialDiv.innerHTML = html;
  return initialDiv.textContent || initialDiv.innerText || '';
}
